<template>
  <section class="table-section">
    <Breadcrumbs :crumbs="crumbs"/>
    <nav class="level">
      <!-- Left side -->
      <div class="level-left">
        <div class="level-item">
          <b-select v-model="defaultSortDirection">
            <option value="asc">Default sort: ASC</option>
            <option value="desc">Default sort: DESC</option>
          </b-select>
        </div>
        <div class="level-item">
          <b-select v-model="perPage" :disabled="!isPaginated">
            <option value="5">5 per page</option>
            <option value="10">10 per page</option>
            <option value="15">15 per page</option>
            <option value="20">20 per page</option>
          </b-select>
        </div>
        <div class="level-item">
          <div class="control is-flex">
            <b-switch v-model="isPaginated">Show Per Page</b-switch>
          </div>
        </div>
      </div>
      <!-- Right side -->
      <div class="level-right">
        <p class="level-item">
          <b-datepicker
            v-model="startDate"
            placeholder="Start Date"
            icon="calendar-today"
            editable>
          </b-datepicker>
        </p>
        <p class="level-item">
          <b-datepicker
            v-model="endDate"
            placeholder="End Date"
            icon="calendar"
            editable>
          </b-datepicker>
        </p>
        <p class="level-item">
          <b-button icon-left="magnify" type="is-primary"
            @click="loadData">
            Search
          </b-button>
        </p>
      </div>
    </nav>
    <b-table
      class="table-fields"
      :data="data"
      :paginated="isPaginated"
      :per-page="perPage"
      :current-page.sync="currentPage"
      :default-sort-direction="defaultSortDirection"
      default-sort="InvoiceNum"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      :striped="true"
      :hoverable="true"
      :loading="isLoading"
      :selected.sync="selected"
      @dblclick="openModal"
    >
      <template slot-scope="props">
        <b-table-column field="CustCode" label="Code" width="50" sortable>
          {{ props.row.CustCode }}
        </b-table-column>
        <b-table-column
          field="InvoiceNum"
          label="Invoice No."
          sortable
        >{{ props.row.InvoiceNum }}</b-table-column>
        <b-table-column
          field="CustName"
          label="Customer"
          sortable
        >{{ props.row.CustName }}</b-table-column>
        <b-table-column
          field="Total"
          label="Total"
          sortable numeric
        ><span class="is-pulled-left">Rp</span>
        {{ props.row.Total | formatCurrency }}</b-table-column>
        <b-table-column
          field="TransDate"
          label="Transaction Date"
          sortable centered>
          <span class="tag is-success">{{ props.row.TransDate }}</span>
        </b-table-column>
      </template>
    </b-table>
    <b-modal :active.sync="isCardModalActive">
      <b-loading :is-full-page="false" :active.sync="modalLoading" :can-cancel="true" />
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title has-text-left">
            Detail <span class="is-size-6">Invoice No.{{ modaldata.InvoiceNum }}</span></p>
          <a @click="isCardModalActive = false">
            <b-icon icon="close-circle" />
          </a>
        </header>
        <section class="modal-card-body">
          <div class="columns">
            <div class="column" v-for="i in Math.ceil(modalfields.length / 4)"
              :key="`modalcol-${i}`">
              <div class="field is-horizontal"
                v-for="item in modalfields.slice((i - 1) * 4, i * 4)"
                :key="`modalcontent-${item.field}`" >
                <div class="field-label is-normal">
                  <label class="label">{{ item.label }}</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control" v-if="item.type === 'currency'">
                      Rp {{ modalheaders[item.field] | formatCurrency }}
                    </div>
                    <div class="control" v-else-if="item.type === 'status'">
                      <span class="tag is-primary"> {{ modalheaders[item.field] }} </span>
                    </div>
                    <div class="control" v-else-if="item.type === 'date'">
                      <span class="tag is-success"> {{ modalheaders[item.field] }} </span>
                    </div>
                    <div class="control" v-else>{{ modalheaders[item.field] }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <b-table
            class="table-fields"
            :data="modaldata"
            :per-page="5"
            :paginated="true"
            default-sort-direction="ASC"
            default-sort="index"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
            :striped="true"
            :hoverable="true"
          >
            <template slot-scope="props">
              <b-table-column label="ID" width="20" sortable>
                {{props.index + 1}}
              </b-table-column>
              <b-table-column
                field="ItemDescription"
                label="Item Description"
                sortable
              >{{ props.row.ItemDescription }}</b-table-column>
              <b-table-column
                field="Qty"
                label="Qty"
                width="30"
                sortable numeric
              >{{ props.row.Qty }}</b-table-column>
              <b-table-column
                field="Price"
                label="Price"
                sortable numeric
              >Rp {{ props.row.Price | formatCurrency }}</b-table-column>
              <b-table-column
                field="SubTotal"
                label="Subtotal"
                sortable numeric
              >Rp {{ props.row.SubTotal| formatCurrency }}</b-table-column>
            </template>
          </b-table>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="isCardModalActive = false">Close</button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs.vue';

export default {
  name: 'Sales',
  components: {
    Breadcrumbs,
  },
  data() {
    return {
      data: [],
      isPaginated: true,
      isPaginationSimple: false,
      defaultSortDirection: 'asc',
      currentPage: 1,
      perPage: 10,
      selected: {},
      isLoading: false,
      isCardModalActive: false,
      crumbs: [
        { title: 'Sales Summary', to: '/sales', active: true },
      ],
      details: {},
      modalfields: [
        { field: 'CustName', label: 'Customer Name', type: 'text' },
        { field: 'InvoiceNum', label: 'Invoice No.', type: 'text' },
        { field: 'Payment', label: 'Payment', type: 'status' },
        { field: 'TotalBruto', label: 'Total Bruto', type: 'currency' },
        { field: 'TotalDisc', label: 'Total Disc', type: 'currency' },
        { field: 'TotalNetto', label: 'Total Netto', type: 'currency' },
        { field: 'TotalTax', label: 'Total Tax', type: 'currency' },
        { field: 'TransDate', label: 'Transaction Date', type: 'date' },
      ],
      modalheaders: {},
      modaldata: [],
      modalLoading: false,
      startDate: new Date(),
      endDate: new Date(),
    };
  },
  methods: {
    loadData() {
      this.isLoading = true;
      const token = this.$store.state.accessToken.split('.');
      const user = atob(token[4]);
      const pass = atob(token[5]);
      const dateStart = `${this.$filters.padzero(this.startDate.getMonth() + 1)}/${this.startDate.getDate()}/${this.startDate.getFullYear()}`;
      const dateEnds = `${this.$filters.padzero(this.endDate.getMonth() + 1)}/${this.endDate.getDate()}/${this.endDate.getFullYear()}`;
      const url = `ViewSalesSummary?_username=${user}&_password=${pass}&_startingDate=${dateStart}&_endingDate=${dateEnds}&_startingCust=&_endingCust=`;
      window.axios.post(url).then((r) => {
        this.isLoading = false;
        if (r.data.Result === 'TRUE') {
          this.data = r.data.TSalesSummary;
        } else {
          console.log(r);
        }
      }).catch((e) => {
        this.isLoading = false;
        console.log(e);
      });
    },
    loadDetail(id) {
      this.modalLoading = true;
      const token = this.$store.state.accessToken.split('.');
      const user = atob(token[4]);
      const pass = atob(token[5]);
      const url = `ViewSalesDetail?_username=${user}&_password=${pass}&_invoiceNum=${id}`;
      window.axios.post(url).then((r) => {
        this.modalLoading = false;
        if (r.data.Result === 'TRUE') {
          const data = r.data.TSalesDetail;
          const detail = data[0];
          this.modalheaders = detail;
          this.modaldata = data;
        } else {
          this.$dialog.alert(r.data.Result);
        }
      }).catch((e) => {
        this.modalLoading = false;
        this.$dialog.alert(e);
      });
    },
    openModal() {
      this.isCardModalActive = true;
      this.loadDetail(this.selected.InvoiceNum);
    },
  },
};
</script>
<style lang="scss" scoped>
.table-section {
  padding: 1rem;
  .table-fields {
    padding: 1rem;
    background: #FFFFFF;
    border: 1px solid #cccccc;
  }
}
.modal-card-body {
  text-align: left;
  .field-body {
    -webkit-box-flex: 2;
    -ms-flex-positive: 2;
    flex-grow: 2;
    padding-top: 0.375em;
  }
}
</style>
